<script>
import {
  findEquipmentList
} from "@/api/sync";

export default {
  name: 'OilDeviceList',
  data() {
    return {
      deviceList: [],
      visible: false
    }
  },
  mounted() {

  },
  methods: {
    open()  {
      this.visible = true
      this.fetchList()
    },
     async fetchList() {
        const res = await findEquipmentList();
        this.deviceList = res.result
    }
  },

}

</script>

<template>
  <el-dialog :visible.sync="visible" title="设备列表" width="80vw" >
    <el-table :data="deviceList">
      <el-table-column label="设备名称" prop="deviceName" show-overflow-tooltip/>
      <el-table-column label="设备编码" prop="deviceCode" show-overflow-tooltip />
      <el-table-column label="市平台" prop="sid" show-overflow-tooltip />
      <el-table-column label="设备类型" prop="deviceType" />
      <el-table-column label="购买日期" prop="buyTime" show-overflow-tooltip />
      <el-table-column label="质保开始日期" prop="zbrqSta" show-overflow-tooltip />
      <el-table-column label="质保结束日期" prop="zbrqEnd" show-overflow-tooltip />
      <el-table-column label="设备供应商" prop="supplier" show-overflow-tooltip />
      <el-table-column label="标签类型" prop="labelType" />
      <el-table-column label="打印机规格" prop="printerGg" />
      <el-table-column label="油桶规格" prop="oilGg" />
      <el-table-column label="软件版本" prop="softVersion" />
      <el-table-column label="设备验证码" prop="deviceCaptcha" />
    </el-table>
  </el-dialog>

</template>

<style scoped>

</style>
